(() => {
  const originalFetch = window.fetch.bind(window);
  async function refreshChangedCart(response) {
    if (!response.ok) return response;
    let cart;
    try { cart = await response.clone().json(); } catch { return response; }
    if (!Array.isArray(cart.items)) return response;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return response;
    if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) {
      const root = window.Shopify?.routes?.root || '/';
      const sectionsResponse = await originalFetch(`${root}?sections=cart-drawer,cart-icon-bubble`, { credentials: 'same-origin' });
      if (!sectionsResponse.ok) return response;
      cart.sections = await sectionsResponse.json();
    }
    if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) return response;
    setTimeout(() => {
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      drawer.renderContents(cart, true);
      drawer.querySelectorAll('.cart__items--disabled').forEach(node => node.classList.remove('cart__items--disabled'));
    }, 0);
    return response;
  }
  const source = () => document.querySelector('.fr-extra-options[data-maker-ids]');
  const active = () => document.querySelector('.fr-order-care');
  const selected = () => [...(active()?.querySelectorAll('.fr-care-toggle[aria-checked="true"]') || [])].filter(x => x.dataset.variantId);
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: source()?.dataset.currency || 'USD' }).format(amount / 100);
  function totals() {
    const config = source();
    if (!config) return;
    const info = config.closest('.product__info-container');
    const bundles = info?.querySelector('quantity-breaks');
    if (!bundles) return;
    let summary = info.querySelector('.fr-care-total');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'fr-care-total';
      summary.setAttribute('aria-live', 'polite');
      summary.innerHTML = '<span></span><strong></strong><small></small>';
      summary.querySelector('span').textContent = window.frostlyMobileLabels?.selectionTotal || 'Selection total';
      summary.querySelector('small').textContent = window.frostlyMobileLabels?.taxNote || 'USD · Tax at checkout.';
      const purchase = info.querySelector('product-form');
      if (purchase) purchase.before(summary);
      else bundles.after(summary);
    }
    const quantity = Number(bundles.querySelector('input[type="radio"]:checked')?.value || 1);
    const makerPrice = Number(config.dataset.unitPrice);
    const saving = quantity >= 3 ? Number(config.dataset.trioSaving || 0) : quantity === 2 ? Number(config.dataset.pairSaving || 0) : 0;
    const carePrice = selected().reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
    const formatted = money(quantity * makerPrice - saving + carePrice);
    summary.querySelector('strong').textContent = formatted;
    document.querySelectorAll('.sticky-atc__price').forEach(price => {
      if (price.textContent !== formatted) price.textContent = formatted;
      if (!price.dataset.frostlyObserved) {
        price.dataset.frostlyObserved = 'true';
        new MutationObserver(totals).observe(price, { childList: true, subtree: true });
      }
    });
  }
  function readForm(form) {
    const indexed = new Map();
    for (const [key, value] of form.entries()) {
      const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      if (match) {
        const index = Number(match[1]);
        if (!indexed.has(index)) indexed.set(index, {});
        indexed.get(index)[match[2]] = value;
      }
    }
    if (indexed.size) return [...indexed.values()];
    if (form.get('id')) return [{ id: form.get('id'), quantity: Number(form.get('quantity') || 1) }];
    return [];
  }
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input?.url;
    if (/\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/.test(url || '') && (init?.method || 'GET').toUpperCase() === 'POST') {
      const response = await originalFetch(input, init);
      if (!response.ok) return response;
      let updated;
      try { updated = await response.clone().json(); } catch { return response; }
      if (!Array.isArray(updated.items)) return response;
      const makerIds = new Set(['67683271606517', '67683271639285']);
      const careIds = new Set(['67689510732021', '67689510764789']);
      if (updated.items.some(item => makerIds.has(String(item.variant_id || item.id)))) return refreshChangedCart(response);
      const orphaned = updated.items.filter(item => careIds.has(String(item.variant_id || item.id)));
      if (!orphaned.length) return refreshChangedCart(response);
      const root = window.Shopify?.routes?.root || '/';
      const body = { updates: Object.fromEntries(orphaned.map(item => [item.key || item.variant_id || item.id, 0])), sections: Object.keys(updated.sections || {}).slice(0, 5), sections_url: window.location.pathname };
      const clean = await originalFetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) });
      if (!clean.ok) throw new Error(window.frostlyMobileLabels?.careError || 'Unable to update your care options. Please try again.');
      return refreshChangedCart(clean);
    }
    const config = source();
    if (!config || !init?.body || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(url || '') || (init.method || 'GET').toUpperCase() !== 'POST') return originalFetch(input, init);
    const makers = new Set(config.dataset.makerIds.split(','));
    const isForm = init.body instanceof FormData;
    let payload;
    let items;
    if (isForm) items = readForm(init.body);
    else {
      try { payload = typeof init.body === 'string' ? JSON.parse(init.body) : null; } catch { return originalFetch(input, init); }
      if (!payload) return originalFetch(input, init);
      items = payload.items || (payload.id ? [{ id: payload.id, quantity: Number(payload.quantity || 1), properties: payload.properties, selling_plan: payload.selling_plan }] : []);
    }
    if (!items.some(item => makers.has(String(item.id)))) return originalFetch(input, init);
    const choices = selected();
    if (!choices.length) return originalFetch(input, init);
    const root = window.Shopify?.routes?.root || '/';
    const existingResponse = await originalFetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!existingResponse.ok) throw new Error('Unable to check your cart. Please try again.');
    const cart = await existingResponse.json();
    const existing = new Set([...(cart.items || []).map(item => String(item.variant_id || item.id)), ...items.map(item => String(item.id))]);
    const additions = choices.filter(item => !existing.has(item.dataset.variantId)).map(item => ({ id: Number(item.dataset.variantId), quantity: 1, properties: { _Covers: 'Frostly makers in this order' } }));
    if (!additions.length) return originalFetch(input, init);
    const next = { ...init };
    if (isForm) {
      const form = new FormData();
      const hasIndexed = [...init.body.keys()].some(key => /^items\[\d+\]\[id\]$/.test(key));
      for (const [key, value] of init.body.entries()) {
        if (!hasIndexed && ['id', 'quantity', 'selling_plan'].includes(key)) continue;
        if (!hasIndexed && /^properties\[/.test(key)) form.append(`items[0][properties][${key.slice(11, -1)}]`, value);
        else form.append(key, value);
      }
      if (!hasIndexed) {
        form.append('items[0][id]', String(items[0].id));
        form.append('items[0][quantity]', String(items[0].quantity || 1));
        if (init.body.get('selling_plan')) form.append('items[0][selling_plan]', init.body.get('selling_plan'));
      }
      const indices = [...form.keys()].map(key => key.match(/^items\[(\d+)\]/)?.[1]).filter(Boolean).map(Number);
      let index = Math.max(-1, ...indices) + 1;
      for (const item of additions) {
        form.append(`items[${index}][id]`, String(item.id));
        form.append(`items[${index}][quantity]`, '1');
        form.append(`items[${index}][properties][_Covers]`, item.properties._Covers);
        index++;
      }
      next.body = form;
    } else {
      const updated = { ...payload, items: [...items, ...additions] };
      delete updated.id;
      delete updated.quantity;
      delete updated.properties;
      delete updated.selling_plan;
      next.body = JSON.stringify(updated);
    }
    return originalFetch(input, next);
  };
  document.addEventListener('frostly:care-change', totals);
  document.addEventListener('change', event => { if (event.target.matches('quantity-breaks input[type="radio"], quantity-breaks select')) totals(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', totals);
  else totals();
  document.addEventListener('shopify:section:load', totals);
})();
